module.exports = __webpack_public_path__ + "images/7243a0fe88cdba1f232a07c5fb7f67a4-coffee-cup.png";